import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from 'vue';
import CModal from '@/components/CModal.vue';
import CButton from '@/components/shared/CButton';
import CInput from '@/components/shared/CInput.vue';
import MapStyleThumbnail from '@/components/DesignStudio/MapStyleProperties/components/MapStyleThumbnail.vue';
import { MAP_STYLE_PRESETS } from '@/components/DesignStudio/MapStyleProperties/presets';
import type { MapStylePresetType } from '@/components/DesignStudio/MapStyleProperties/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'MapStyleCreateModal',
  props: {
    value: { type: Boolean }
  },
  emits: ["input", "create"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: boolean): void;
    (event: 'create', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value: boolean;
};




const searchInput = ref('');

const filteredPresets = computed(() => {
    const query = searchInput.value.toLowerCase();
    return query ? MAP_STYLE_PRESETS.filter((preset) => preset.label.toLowerCase().includes(query)) : MAP_STYLE_PRESETS;
});

const handleClose = () => {
    emit('input', false);
};

const resetForm = () => {
    searchInput.value = '';
};

const handlePresetSelect = (preset: MapStylePresetType) => {
    emit('create', preset.value);
    handleClose();
};

watch(
    () => props.value,
    (isOpen) => {
        if (!isOpen) {
            resetForm();
        }
    }
);

return { __sfc: true,props, emit, searchInput, filteredPresets, handleClose, resetForm, handlePresetSelect, CModal, CButton, CInput, MapStyleThumbnail }
}

})